var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('DynamicTabs',{staticClass:"mb-4",attrs:{"tabs":_vm.tabs}}),_c('Alert',{staticClass:"mb-4",attrs:{"error":_vm.error}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }